import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Not Equal Sign - Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-not-equal-variant',
    templateUrl: './icon-not-equal-variant.component.html',
    styleUrls: ['./icon-not-equal-variant.component.scss'],
    standalone: false
})
export class IconNotEqualVariantComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
